import { client } from "./supabase";
import { exigirFechaValida } from "./validarFechaDocumento";

export const getPlanPagosEdificios = async (pais) => {
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .select("*, edificio:edificios(id, edificio)")
    .eq("pais", pais)
    .eq("estado", "pendiente")
    .order("fecha_acordada");
  if (error) throw error;
  return data || [];
};

// F1 (B.2b, 2026-09-26): `fecha_acordada` exige `modo` explícito en `opciones` — mismo candado que
// activos.js/crearActivo, adaptado a la firma de parámetros nombrados de este writer.
export const crearPlanPagoEdificio = async (
  { edificio_id, pais, monto, fecha_acordada, nota, created_by },
  opciones = {}
) => {
  exigirFechaValida({ fecha_acordada }, "fecha_acordada", opciones);
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .insert([{ edificio_id, pais, monto, fecha_acordada, nota, created_by, estado: "pendiente" }])
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const actualizarPlanPagoEdificio = async (id, cambios, opciones = {}) => {
  exigirFechaValida(cambios, "fecha_acordada", opciones);
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .update({ ...cambios })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const marcarPlanPagoEdificioPagado = async (id, movimiento_caja_id) => {
  const { data, error } = await client
    .from("plan_pagos_edificios")
    .update({ estado: "pagado", movimiento_caja_id })
    .eq("id", id)
    .select()
    .single();
  if (error) throw error;
  return data;
};

export const anularPlanPagoEdificio = async (id) => {
  const { error } = await client.from("plan_pagos_edificios").update({ estado: "anulado" }).eq("id", id);
  if (error) throw error;
};
